/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CameraScheduleRule } from './cameraScheduleRule';
import { ScheduleRule } from './scheduleRule';


export interface Schedule { 
    cameraScheduleRules?: Array<CameraScheduleRule>;
    rules?: Array<ScheduleRule>;
    scheduleType?: Schedule.ScheduleTypeEnum;
    userDefined?: boolean;
}
export namespace Schedule {
    export const ScheduleTypeEnum = {
        Gps: 'GPS',
        Vhf: 'VHF',
        Communication: 'COMMUNICATION',
        Proximity: 'PROXIMITY',
        ExternalSensorReceiver: 'EXTERNAL_SENSOR_RECEIVER',
        VirtualFence: 'VIRTUAL_FENCE',
        Camera: 'CAMERA',
        HighActivityGps: 'HIGH_ACTIVITY_GPS',
        SolexGps: 'SOLEX_GPS'
    } as const;
    export type ScheduleTypeEnum = typeof ScheduleTypeEnum[keyof typeof ScheduleTypeEnum];
}


export type ScheduleTypeEnum = typeof Schedule.ScheduleTypeEnum[keyof typeof Schedule.ScheduleTypeEnum];
